import { render, staticRenderFns } from "./MantraEdit.vue?vue&type=template&id=81305488&scoped=true&"
import script from "./MantraEdit.vue?vue&type=script&lang=js&"
export * from "./MantraEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81305488",
  null
  
)

export default component.exports